import styled from "styled-components";

export const SSelectOrganizationStepListItemBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
